import { render, staticRenderFns } from "./ContainerBlock.vue?vue&type=template&id=c035f75a&scoped=true&"
import script from "./ContainerBlock.vue?vue&type=script&lang=js&"
export * from "./ContainerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c035f75a",
  null
  
)

export default component.exports